import {GET_IDENTIFICATION_DOCUMENT_BY_ID} from "../../types";

const initialState = {
 identificationDocument:{}
}

export const identificationDocumentsReducer = (state = initialState, action) =>{
    switch (action.type) {
        case GET_IDENTIFICATION_DOCUMENT_BY_ID:{
            return {
                ...state,
                identificationDocument: action.data
            }
        }
        default :return state
    }
}